import crudActions from '../../crud/actions'

const actions = crudActions('SERVICEUSER_CONTACT_')

export default actions
